<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title">{{ 'MOLLIE-ONBOARDING.TITLE' | translate }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span (click)="cancel()">×</span>
        </button>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">
      <div class="row mg-b-25">
        
        <div class="col-lg-12">
          <p class="mb-3">{{ 'MOLLIE-ONBOARDING.DESCRIPTION' | translate }}</p>
        </div>

        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">{{ 'MOLLIE-ONBOARDING.FORM.LABEL.FIRST-NAME' | translate }}<span class="tx-danger">*</span></label>
            <input class="form-control" formControlName="FirstName" [placeholder]="'MOLLIE-ONBOARDING.FORM.PLACEHOLDER.FIRST-NAME' | translate">
            <t4-display-validation controlName="FirstName" [form]="form"></t4-display-validation>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">{{ 'MOLLIE-ONBOARDING.FORM.LABEL.LAST-NAME' | translate }}<span class="tx-danger">*</span></label>
            <input class="form-control" formControlName="LastName" [placeholder]="'MOLLIE-ONBOARDING.FORM.PLACEHOLDER.LAST-NAME' | translate">
            <t4-display-validation controlName="LastName" [form]="form"></t4-display-validation>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{ 'MOLLIE-ONBOARDING.FORM.LABEL.EMAIL' | translate }}<span class="tx-danger">*</span></label>
            <input class="form-control" type="email" formControlName="Email" [placeholder]="'MOLLIE-ONBOARDING.FORM.PLACEHOLDER.EMAIL' | translate">
            <t4-display-validation controlName="Email" [form]="form"></t4-display-validation>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{ 'MOLLIE-ONBOARDING.FORM.LABEL.ORGANIZATION-LEGAL-NAME' | translate }}<span class="tx-danger">*</span></label>
            <input class="form-control" formControlName="OrganizationLegalName" [placeholder]="'MOLLIE-ONBOARDING.FORM.PLACEHOLDER.ORGANIZATION-LEGAL-NAME' | translate">
            <t4-display-validation controlName="OrganizationLegalName" [form]="form"></t4-display-validation>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{ 'MOLLIE-ONBOARDING.FORM.LABEL.COUNTRY-ISO-CODE' | translate }}</label>
            <input class="form-control" formControlName="CountryIsoCode" [placeholder]="'MOLLIE-ONBOARDING.FORM.PLACEHOLDER.COUNTRY-ISO-CODE' | translate">
            <t4-display-validation controlName="CountryIsoCode" [form]="form"></t4-display-validation>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="saving">{{ 'MOLLIE-ONBOARDING.BUTTON.CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving || form.invalid">
      @if (saving) {
        <span class="spinner-border spinner-border-sm me-2"></span>
      }
      {{ 'MOLLIE-ONBOARDING.BUTTON.START-ONBOARDING' | translate }}
    </button>
  </div>
</form>
